import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const removeUserRolesSlice = createSlice({
  name: "removeUserRoles",
  initialState,
  reducers: {
    removeUserRolesRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    removeUserRolesRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    removeUserRolesRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  removeUserRolesRequested,
  removeUserRolesRequestFailed,
  removeUserRolesRequestSucceeded,
} = removeUserRolesSlice.actions;

export default removeUserRolesSlice.reducer;
